<script>
// Zone d'action de l'invitation à rejoindre l'équipe Talkizy (côté admin) :
//  - autorisé (canJoin) : bouton pour se créer son propre compte Talkizy ;
//  - non autorisé : message invitant à solliciter le propriétaire de l'espace.
export default {
  name: 'TalkizyJoinActions',
  props: {
    canJoin: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <div>
    <template v-if="canJoin">
      <div class="talkizyjoinactions_buttons mb-4">
        <b-button
          type="is-primary"
          size="is-medium"
          :loading="isLoading"
          @click="$emit('join')"
        >
          Activer mon accès Talkizy
        </b-button>
      </div>
      <p class="talkizyjoinactions_hint is-size-8 has-text-grey-dark">
        <b-icon icon="check-circle" size="is-small" type="is-primary" />
        Votre accès Talkizy sera automatiquement créé et rattaché à l'espace déjà configuré
      </p>
    </template>

    <div v-else class="talkizyjoinactions_locked notification is-warning is-light mx-auto">
      <p class="has-text-weight-bold mb-1">
        Vous ne pouvez pas encore vous connecter à Talkizy
      </p>
      <p class="is-size-8">
        Le plan actuel de l'espace ne permet pas d'ajouter de membre d'équipe supplémentaire.
        Demandez au propriétaire de l'espace de faire le nécessaire (mise à niveau du forfait)
        pour que vous puissiez activer votre compte Talkizy et animer vos propres classes virtuelles.
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.talkizyjoinactions {
  &_buttons {
    display: flex;
    justify-content: center;

    .button {
      min-width: 220px;
    }
  }

  &_hint .icon {
    vertical-align: middle;
  }

  &_locked {
    max-width: 520px;
    text-align: left;
  }
}
</style>
